<template>
    <q-card
        :inline="inline"
        :class="['card', 'q-ma-sm', {inEdit: inEdit, viewer: viewer, draggingOver: draggingOver}]"
        :style="style"
        ref="card"
        v-if="article">
        <q-card-title>
            <div class="title" v-if="! inEdit">{{article.title}}</div>
            <q-field
                v-else
                :error="$v.article.title.$error"
                error-label="Pole nie może być puste">
                <q-input
                    v-model="article.title"
                    @input="validate"></q-input>
            </q-field>

        </q-card-title>

        <template>
            <q-card-main class="main">
                <p v-if="! inEdit" v-html="article.description"></p>
                <!--<q-editor v-if="inEdit && localModel.description != null" v-model="localModel.description"/>-->

                <q-card class="new-content-area q-mt-md q-mb-md" v-if="! viewer">
                    <div class="text-center">
                        Skrót artykułu
                    </div>

                    <q-editor @paste.native="paste" v-model="article.summary" v-if="inEdit" class="summary"/>
                    <div v-else v-html="article.summary" class="summary"/>
                </q-card>

                <div class="badges q-ma-sm text-right">
                    <category-chooser v-if="!kb && inEdit"
                                      :category="article.category"
                                      @selected="setCategory"/>

                    <category-chooser v-if="kb && inEdit"
                                      :kb="true"
                                      :category="article.kbCategory"
                                      @selected="setCategory"/>

                    <div v-if="!inEdit && categoryName">
                        Kategoria: {{categoryName}}
                    </div>

                    <group-switcher @change="value => article.group = value" :value="article.group" :disabled="! inEdit"/>
                </div>


                <!--<q-field label="Tagi">-->
                <!--<q-chips-input label="Dodaj tag" v-model="article.tags" :readonly="!inEdit"/>-->
                <!--</q-field>-->
            </q-card-main>

            <q-card-actions v-if="!inEdit && !viewer" align="end" class="actions">
                <publish-button :model="article" what="article"/>
                <q-btn flat round icon="file_copy" @click.native="cloneArticle">
                    <q-tooltip>
                        Wykonaj kopię
                    </q-tooltip>
                </q-btn>
                <q-btn flat round icon="edit" @click.native="goToEdit(article.articleId)"/>
                <q-btn flat round icon="delete" @click.native="confirmAndDelete"/>
            </q-card-actions>

            <q-card-actions v-if="inEdit" align="end" class="actions"
                            @dragover.native.prevent="dragover"
                            @dragleave.native="dragleave"
                            @dragenter.native="dragenter"
                            @drop.native="dropBackground">
                <!--<q-btn flat round icon="save" @click.native="save"/>-->
                <q-btn flat round icon="delete" @click.native="confirmAndDelete"/>
            </q-card-actions>
        </template>
    </q-card>
</template>

<script>
    import QCardTitle from 'quasar-framework/src/components/card/QCardTitle'
    import QCardMedia from 'quasar-framework/src/components/card/QCardMedia'
    import QCardMain from 'quasar-framework/src/components/card/QCardMain'
    import QCardActions from 'quasar-framework/src/components/card/QCardActions'
    import QIcon from 'quasar-framework/src/components/icon/QIcon'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import QEditor from 'quasar-framework/src/components/editor/QEditor'
    import QField from 'quasar-framework/src/components/field/QField'
    import GenericViewer from './viewers/GenericViewer'
    import QCard from 'quasar-framework/src/components/card/QCard'
    import QChipsInput from 'quasar-framework/src/components/chips-input/QChipsInput'
    import draggable from 'vuedraggable'
    import QToggle from 'quasar-framework/src/components/toggle/QToggle'
    import GroupSwitcher from '../GroupSwitcher'
    import PublishButton from './PublishButton'
    import CategoryChooser from '../CategoryChooser'

    import {required, minLength} from 'vuelidate/lib/validators'
    import QTooltip from 'quasar-framework/src/components/tooltip/QTooltip'
    import { pasteCapture } from '../../lib/editor-paste'

    export default {
        name: 'ArticleComponent',
        components: {
            QTooltip,
            CategoryChooser,
            PublishButton,
            GroupSwitcher,
            QToggle,
            QChipsInput,
            QCard,
            GenericViewer,
            QField,
            QEditor,
            QBtn,
            QIcon,
            QCardActions,
            QCardMain,
            QCardMedia,
            QCardTitle,
            draggable,
        },
        props: ['model', 'editable', 'inEdit', 'inline', 'kb', 'viewer'],
        methods: {
            paste (evt) {
                pasteCapture(evt, this.$refs.editor_ref);
            },
            cloneArticle () {
                const article = this.article

                const articleId = this.$uuid()

                const model = {
                    ...article,
                    articleId,
                    title: 'Kopia ' + article.title,
                    parts: article.parts.map(part => {
                        const articlePartId = this.$uuid()

                        return {
                            ...part,
                            articlePartId,
                            articleId,
                        }
                    }),
                    publicationInformation: undefined,
                }

                this.$store.dispatch('create', {
                    what: 'article',
                    item: model
                })
            },
            goToEdit (articleId) {
                const routeName = this.kb ? 'article-edit' : 'polearticles-edit'

                this.$router.push({
                    name: routeName,
                    params: {articleId},
                })
            },

            dragenter () {

            },
            dragover () {
                if (this.inEdit) {
                    this.draggingOver = true
                }
            },
            dragleave () {
                if (this.inEdit) {
                    this.draggingOver = false
                }
            },
            dropTasklet (e) {
                if (this.inEdit) {
                    e.preventDefault()

                    try {
                        var tasklet = JSON.parse(e.dataTransfer.getData('text'))
                        if (tasklet.type !== 'survey') {
                            let type = tasklet.type

                            if (type === 'text') {
                                this.article.parts.push({
                                    articlePartId: this.$uuid(),
                                    category: type,
                                    text: tasklet.text,
                                    // url: p.url,
                                    // url: tasklet.urlPath
                                })
                            } else {
                                this.article.parts.push({
                                    articlePartId: this.$uuid(),
                                    category: type,
                                    // text: p.text,
                                    // url: p.url,
                                    url: tasklet.urlPath
                                })
                            }
                        }
                    } catch (ee) {
                        //
                    }

                    this.draggingOver = false
                }
            },
            dropBackground (/*e*/) {

            },
            save () {

            },
            fetch () {

            },
            fetchDetailsIfNecessary () {

            },
            removeArticle (part) {
                this.article.parts = this.article.parts.filter(p => p !== part)
            },
            addTextToArticle () {
                this.article.parts.push({
                    articlePartId: this.$uuid(),
                    category: 'text',
                    text: this.text,
                })

                this.text = ''
            },
            confirmAndDelete () {
                if (! this.article.isNew) {
                    this.$q.dialog({
                        title: `Potwierdź usunięcie artykułu`,
                        message: `Czy na pewno usunąć artykuł ${this.article.title}?`,
                        ok: 'Usuń',
                        cancel: 'Anuluj',
                        position: 'top',
                    }).then(() => {
                        this.$store.dispatch('remove', {
                            what: 'article',
                            id: this.article.articleId
                        }).then(() => {
                            this.$emit('deleted')
                        })
                    }).catch(() => {

                    })
                } else {
                    this.$emit('deleted')
                }
            },

            validate () {
                this.$v.$touch()

                this.$emit('valid', this.valid)
            },

            setCategory (category) {
                if (this.kb) {
                    this.$set(this.article, 'kbCategory', category)
                } else {
                    this.$set(this.article, 'category', category)
                }

                this.validate()
            }
        },
        data () {
            return {
                draggingOver: false,
                isNew: false,
                text: ''
            }
        },
        mounted () {
            this.fetchDetailsIfNecessary()

            this.validate()
        },
        watch: {
            model (now, old) {
                if (now.id && now.id !== old.id) {
                    this.fetchDetailsIfNecessary()
                }
            },
        },
        computed: {
            article () {
                // if (this.$store.state.poles.filter(p => p.id === this.model.id).length > 0) {
                //     return this.$store.state.poles.find(p => p.id === this.model.id)
                // }

                return this.model
            },
            style () {
                return ''
            },
            valid () {
                return ! this.$v.$invalid
            },
            categoryName () {
                if (this.kb) {
                    const c = this.$store.getters.kbCategory.find(c => c.kbCategory === this.article.kbCategory)
                    return c && c.label
                } else {
                    const c = this.$store.getters.category.find(c => c.category === this.article.category)
                    return c && c.label
                }
            }
        },
        validations () {
            if (this.inEdit) {
                return {
                    article: {
                        title: {
                            required,
                            minLength: minLength(1)
                        },
                        ...this.kb ? {
                            kbCategory: {
                                required,
                                minLength: minLength(1)
                            }
                        } : {},
                        ...!this.kb ? {
                            category: {
                                required,
                                minLength: minLength(1)
                            }
                        } : {},

                    }
                }

            } else {
                return {}
            }
        },

    }
</script>

<style scoped lang="scss">
    .card {
        .actions {
            background: gainsboro;
        }

        border-radius: 20px;
    }

    .card:not(.inEdit) {
        &:not(.viewer) {
            width: 350px;
        }
        &.viewer {
            width: 150px;
        }
        /*height: 500px;*/
        overflow: hidden;
        position: relative;

        .summary {
            height: 120px;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        .title {
            height: 2rem;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .media {

        }

        .main {

        }
    }

    .card.inEdit {
        width: 350px;
        position: relative;

        .summary {
            height: 300px;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        .media {

        }

        .main {

        }

        &.draggingOver {
            border: 1px solid red;
        }
    }

    .new-content-area {
        border: 1px dashed gray;
        min-height: 30px;
        line-height: 30px;
        color: gray;
    }

</style>
